export default __webpack_public_path__ + "static/media/IMG_3896 - Copy - Copy (2).b0042543.jpg";